import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';

import { useFeatureFlags } from '@/api/feature-flags';
import MobileIcon from '@/assets/images/mobile-icon.svg';
import routes from '@/routes/routes.json';

import { useHeaderProducts } from '../../hooks/useNavProducts';
import { AvailableProducts } from './HeaderData';

const HeaderProductMobile = ({ activeHeaderTab, onClickCloseSidebar }: any) => {
  return (
    <div>
      {useHeaderProducts().map((eachProduct: any) => {
        return Object.entries(eachProduct)?.map(([key, values]: any) => {
          return (
            key === activeHeaderTab &&
            values.map((eachValue: any, idx: number) => {
              return (
                <Link
                  href={eachValue.ProductPathName}
                  key={idx}
                  onClick={onClickCloseSidebar}
                >
                  <div className="commons-header-product-card">
                    <h1 className="commons-header-product-title">
                      {eachValue.ProductTitle}
                    </h1>
                    <p className="commons-header-product-info">
                      {eachValue.ProductInfo}
                    </p>
                  </div>
                </Link>
              );
            })
          );
        });
      })}
    </div>
  );
};

export const HeaderMobile = ({ open, setOpen }: any) => {
  /* eslint-disable */
  const [activeDetailsTab, setActiveDetailsTab] = useState({
    GoldLoan: false,
    DigitalGold: false,
    Forex: false,
    NCD: false,
    Payments: false,
    Blogs: false,
    Careers: false,
  });

  const { featureFlags, isFlagsFetched } = useFeatureFlags();

  const onClickDetailsTab = (value: any) => {
    const temp = Object.assign(activeDetailsTab);
    // eslint-disable-next-line
    Object.keys(temp).map((e) => {
      if (e === value) {
        temp[e] = !temp[e];
      } else {
        temp[e] = false;
      }
    });
    setActiveDetailsTab({ ...temp });
  };

  const onClickCloseSidebar = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open === false) {
      setActiveDetailsTab({
        GoldLoan: false,
        DigitalGold: false,
        Forex: false,
        NCD: false,
        Payments: false,
        Blogs: false,
        Careers: false,
      });
    }
  }, [open]);

  return (
    <>
      {open && (
        <div
          onClick={() => {
            setOpen(false);
          }}
          className="commons-mobile-header-sidebar-container"
        >
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={`commons-mobile-header-parent-container`}
          >
            {/* Gold Loan */}
            <div
              className={`commons-mobile-header-each-tab-container ${
                activeDetailsTab.GoldLoan &&
                'commons-mobile-header-each-tab-container-active'
              }`}
            >
              <div className="commons-mobile-header-tab">
                <Link
                  href={routes.goldLoan}
                  onClick={onClickCloseSidebar}
                  id="header_gold-loans"
                  className="commons-mobile-header-name"
                >
                  Gold Loan
                </Link>

                {/* <span
                  onClick={() => onClickDetailsTab('GoldLoan')}
                  id="GoldLoan"
                  className={`circleArrow-icon ${
                    activeDetailsTab.GoldLoan
                      ? 'commons-mobile-header-arrow-active'
                      : 'commons-mobile-header-arrow'
                  }`}
                ></span> */}
              </div>
              {/* <div
                className={`commons-mobile-header-info-tab ${
                  activeDetailsTab.GoldLoan &&
                  'common-mobile-header-info-tab-active'
                }`}
              >
                {activeDetailsTab.GoldLoan && (
                  <HeaderProductMobile
                    activeHeaderTab={AvailableProducts.GoldLoan}
                    onClickCloseSidebar={onClickCloseSidebar}
                  />
                )}
              </div> */}
            </div>
            {!activeDetailsTab.GoldLoan && (
              <hr className="commons-mobile-header-hr" />
            )}
            {/* Digital Gold */}
            <div
              className={`commons-mobile-header-each-tab-container ${
                activeDetailsTab.DigitalGold &&
                'commons-mobile-header-each-tab-container-active'
              }`}
            >
              <div className="commons-mobile-header-tab">
                <Link
                  href={routes.digitalGoldHome}
                  onClick={onClickCloseSidebar}
                  id="header_digital-gold"
                  className="commons-mobile-header-name"
                >
                  eSwarna Digital Gold
                </Link>

                {/* <span
                  onClick={() => onClickDetailsTab("DigitalGold")}
                  id="DigitalGold"
                  className={`circleArrow-icon ${
                    activeDetailsTab.DigitalGold
                      ? "commons-mobile-header-arrow-active"
                      : "commons-mobile-header-arrow"
                  }`}
                ></span> */}
              </div>
              {/* <div
                className={`commons-mobile-header-info-tab ${
                  activeDetailsTab.DigitalGold &&
                  "common-mobile-header-info-tab-active"
                }`}
              >
                {activeDetailsTab.DigitalGold && (
                  <HeaderProductMobile
                    activeHeaderTab={AvailableProducts.DigitalGold}
                    onClickCloseSidebar={onClickCloseSidebar}
                  />
                )}
              </div> */}
            </div>
            {!activeDetailsTab.DigitalGold && (
              <hr className="commons-mobile-header-hr" />
            )}

            {/* NCD */}
            {featureFlags.release_ncd && isFlagsFetched && (
              <>
                <div
                  className={`commons-mobile-header-each-tab-container ${
                    activeDetailsTab.NCD &&
                    'commons-mobile-header-each-tab-container-active'
                  }`}
                >
                  <div className="commons-mobile-header-tab">
                    <Link
                      href={routes.ncdHome}
                      onClick={onClickCloseSidebar}
                      id="header_ncd"
                      className="commons-mobile-header-name"
                    >
                      NCD
                    </Link>
                    {/* 
                <span
                  onClick={(e) => onClickDetailsTab("NCD")}
                  id="NCD"
                  className={`circleArrow-icon ${
                    activeDetailsTab.NCD
                      ? "commons-mobile-header-arrow-active"
                      : "commons-mobile-header-arrow"
                  }`}
                ></span> */}
                  </div>
                  {/* <div
                    className={`commons-mobile-header-info-tab ${
                      activeDetailsTab.NCD &&
                      "common-mobile-header-info-tab-active"
                    }`}
                  >
                    {activeDetailsTab.NCD && (
                      <HeaderProductMobile
                        activeHeaderTab={AvailableProducts.Ncd}
                        onClickCloseSidebar={onClickCloseSidebar}
                      />
                    )}
                  </div> */}
                </div>
                {!activeDetailsTab.NCD && (
                  <hr className="commons-mobile-header-hr" />
                )}
              </>
            )}

            {/* Forex */}
            <div
              className={`commons-mobile-header-each-tab-container ${
                activeDetailsTab.Forex &&
                'commons-mobile-header-each-tab-container-active'
              }`}
            >
              <div className="commons-mobile-header-tab">
                <Link
                  href={routes.forex}
                  onClick={onClickCloseSidebar}
                  id="header_forex"
                  className="commons-mobile-header-name"
                >
                  Forex
                </Link>

                <span
                  onClick={() => onClickDetailsTab('Forex')}
                  id="Forex"
                  className={`circleArrow-icon ${
                    activeDetailsTab.Forex
                      ? 'commons-mobile-header-arrow-active'
                      : 'commons-mobile-header-arrow'
                  }`}
                ></span>
              </div>
              <div
                className={`commons-mobile-header-info-tab ${
                  activeDetailsTab.Forex &&
                  'common-mobile-header-info-tab-active'
                }`}
              >
                {activeDetailsTab.Forex && (
                  <HeaderProductMobile
                    activeHeaderTab={AvailableProducts.Forex}
                    onClickCloseSidebar={onClickCloseSidebar}
                  />
                )}
              </div>
            </div>
            {!activeDetailsTab.Forex && (
              <hr className="commons-mobile-header-hr" />
            )}

            {/* Payments */}
            {featureFlags.release_rv && isFlagsFetched && (
              <>
                <div
                  className={`commons-mobile-header-each-tab-container ${
                    activeDetailsTab.Payments &&
                    'commons-mobile-header-each-tab-container-active'
                  }`}
                >
                  <div className="commons-mobile-header-tab">
                    <Link
                      href={routes.billsLanding}
                      onClick={onClickCloseSidebar}
                      id="header_bills"
                      className="commons-mobile-header-name"
                    >
                      Payments
                    </Link>

                    <span
                      onClick={() => onClickDetailsTab('Payments')}
                      id="Payments"
                      className={`circleArrow-icon ${
                        activeDetailsTab.Payments
                          ? 'commons-mobile-header-arrow-active'
                          : 'commons-mobile-header-arrow'
                      }`}
                    ></span>
                  </div>
                  <div
                    className={`commons-mobile-header-info-tab ${
                      activeDetailsTab.Payments &&
                      'common-mobile-header-info-tab-active'
                    }`}
                  >
                    {activeDetailsTab.Payments && (
                      <HeaderProductMobile
                        activeHeaderTab={AvailableProducts.Payments}
                        onClickCloseSidebar={onClickCloseSidebar}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
            {!activeDetailsTab.Payments && (
              <hr className="commons-mobile-header-hr" />
            )}
            {/* Blogs */}
            <div
              className={`commons-mobile-header-each-tab-container ${
                activeDetailsTab.Blogs &&
                'commons-mobile-header-each-tab-container-active'
              }`}
            >
              <div className="commons-mobile-header-tab">
                <Link
                  href={routes.blogs}
                  onClick={onClickCloseSidebar}
                  id="header_blogs"
                  className="commons-mobile-header-name"
                >
                  Blogs
                </Link>

                {/* <span
                  onClick={(e) => onClickDetailsTab("Blogs")}
                  id="Blogs"
                  className={`circleArrow-icon ${
                    activeDetailsTab.Blogs
                      ? "commons-mobile-header-arrow-active"
                      : "commons-mobile-header-arrow"
                  }`}
                ></span> */}
              </div>
              {/* <div
                className={`commons-mobile-header-info-tab ${
                  activeDetailsTab.Blogs &&
                  "common-mobile-header-info-tab-active"
                }`}
              >
                {activeDetailsTab.Blogs && (
                  <HeaderProductMobile
                    activeHeaderTab={AvailableProducts.Blogs}
                    onClickCloseSidebar={onClickCloseSidebar}
                  />
                )}
              </div> */}
            </div>
            {!activeDetailsTab.Blogs && (
              <hr className="commons-mobile-header-hr" />
            )}

            {/* Careers */}
            <div
              className={`commons-mobile-header-each-tab-container ${
                activeDetailsTab.Careers &&
                'commons-mobile-header-each-tab-container-active'
              }`}
            >
              <div className="commons-mobile-header-tab">
                <Link
                  href={routes.careers}
                  onClick={onClickCloseSidebar}
                  id="header_careers"
                  className="commons-mobile-header-name"
                >
                  Careers
                </Link>

                {/* <span
                  onClick={(e) => onClickDetailsTab("Careers")}
                  id="Careers"
                  className={`circleArrow-icon ${
                    activeDetailsTab.Careers
                      ? "commons-mobile-header-arrow-active"
                      : "commons-mobile-header-arrow"
                  }`}
                ></span> */}
              </div>
              {/* <div
                className={`commons-mobile-header-info-tab ${
                  activeDetailsTab.Careers &&
                  "common-mobile-header-info-tab-active"
                }`}
              >
                {activeDetailsTab.Careers && (
                  <HeaderProductMobile
                    activeHeaderTab={AvailableProducts.Careers}
                    onClickCloseSidebar={onClickCloseSidebar}
                  />
                )}
              </div> */}
            </div>
            {!activeDetailsTab.Careers && (
              <hr className="commons-mobile-header-hr" />
            )}

            {/* Download App CTA */}
            <Link
              href="https://qrco.de/mfone"
              target="_blank"
              className="commons-mobile-header-sidebar-download-cta"
              id="header_download-app"
            >
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={MobileIcon}
                alt="mobile icon"
              />{' '}
              Download App
            </Link>
          </div>
        </div>
      )}
    </>
  );
};
